import { useTextes } from '@common/config';
import { useOrganismeDetailsContext } from '@common/contexts';
import {
  EtablissementDeclarantDto,
  EtablissementProjection,
  OrganismeStatutEtapier,
  useGetAllOrganismeEtablissementsQuery,
  useUpdateOrganismeMutation,
} from '@common/services';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from "../../../../../hooks/store.hook";
import { resetRncpModified } from "../stores/dashboard-stepper.slice";
import { StepStatus } from '../types/enums/step-status.enum';
import { StepBloc, StepButtonProps } from './common/StepBloc';

export const Step3Rncp = () => {
  const t = useTextes('ParcoursOfa', 'EtapierStep3');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id, statutEtapier } = useOrganismeDetailsContext();
  const [updateOrganisme] = useUpdateOrganismeMutation();

  const { data: etablissementsInfo = [] as EtablissementDeclarantDto[] } = useGetAllOrganismeEtablissementsQuery({
    projection: EtablissementProjection.DECLARANT,
    id,
  }, { skip: !id });

  const rncpCount = etablissementsInfo.reduce((acc, etab) => acc + (etab.rncpsCount ?? 0), 0);

  const status: StepStatus = (statutEtapier < OrganismeStatutEtapier.ETAPE_3) ? StepStatus.NEXT // "à venir" si l'étape 2 n'est pas validé
    : (statutEtapier === OrganismeStatutEtapier.ETAPE_3 && rncpCount === 0) ? StepStatus.NEW // "nouveau" si aucun rncp n'est saisi
      : (statutEtapier === OrganismeStatutEtapier.ETAPE_3 && rncpCount > 0) ? StepStatus.PROGRESS // "en cours" si au moins un rncp est saisi
        : StepStatus.DONE;

  const buttonAdd: StepButtonProps = {
    label: 'Ajouter',
    onClick: () => {
      dispatch(resetRncpModified());
      navigate('/mon-ofa/edition/etablissements/rncp');
    },
    priority: 'primary',
  };

  const buttonEdit: StepButtonProps = {
    label: 'Modifier',
    onClick: () => {
      dispatch(resetRncpModified());
      navigate('/mon-ofa/edition/etablissements/rncp');
    },
    priority: 'secondary',
  };

  const buttonValidStep: StepButtonProps = {
    label: 'Étape validée',
    onClick: () => updateOrganisme({ id, dto: { statutEtapier: OrganismeStatutEtapier.ETAPE_4 } }),
    priority: 'secondary',
  };

  const buttons: StepButtonProps[] = [];

  switch (status) {
    case StepStatus.NEW:
      buttonAdd.label = 'Compléter mes RNCP';
      buttons.push(buttonAdd);
      break;
    case StepStatus.PROGRESS:
      buttons.push(buttonAdd, buttonEdit, buttonValidStep);
      break;
    case StepStatus.DONE:
      buttons.push(buttonAdd, buttonEdit);
      break;
  }

  const titleSuffix = `- ${rncpCount} RNCP`;

  return (
    <StepBloc status={status}
              disabled={status === StepStatus.NEXT}
              title={(
                <div className={'flex'}>
                  <span>{t['ETAPE3_TEXTE1']}</span>
                  {(rncpCount > 0 && statutEtapier > OrganismeStatutEtapier.ETAPE_1) &&
                    <span className={'text-[#000091]'}>&nbsp;{titleSuffix}</span>}
                </div>
              )}
              description={t['ETAPE3_TEXTE2']}
              buttons={buttons} />
  );
};